export default __webpack_public_path__ + "static/media/HPE-PROLIANT-DL325-FRONT.12fa06c6.png";